import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {
    whatsapp_get_users_phone({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'whatsapp/get-users-phone/' + form.id + (form.mainPhone ? '?mainPhone='+form.mainPhone : '') + (form.phone ? '&phone='+form.phone : ''))
                .then(
                    response => {
                        console.log(response);
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_send_message({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp/send-message/', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_get_messages({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp/get-messages/', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_send_file({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp/send-file', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_send_audio({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp/send-audio', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_switchImportante({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp/switch-importante', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_downloadInformeMensual({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'whatsapp/download-informe-mensual/' + form.idMono, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_setLeidoFalse({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp/set-leido-false', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_deleteMessage({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp/delete-message', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_switchBloqueado({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp/switch-bloqueado', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    whatsapp_borrar({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'whatsapp/borrar', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};